module.exports = __webpack_public_path__ + "img/tag2.fd52346d.png";